var render = function render(){var _vm=this,_c=_vm._self._c;return _c('billing-report-panel',{attrs:{"report-key":"billing-funnel","route":"/reports/billing-funnel","file-name":"producao-faturado-recebido.xlsx","period-label":"Período da competência","columns":_vm.columns,"default-days":180}})
}
var staticRenderFns = []

export { render, staticRenderFns }